module.exports = __webpack_public_path__ + "static/media/connectSite.2b017668.svg";